import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestQueryGet = {
    path: "/:name/query",
    method: RouteHttpVerb.GET,
    namespace: "search-engine-post-type/v1"
};
export { locationRestQueryGet };
